import { type Dispatch, type SetStateAction, useMemo } from 'react'

import styled from 'styled-components'

import { IconViewersSize } from 'assets/svg/sprite'
import GroupCirclesStory from 'components/UI/GroupCircles/GroupCirclesStory'
import { StoryMessage, StoryMute } from 'components-ref/molecules'
import { useUserProfile } from 'store'
import { type StoryActionType } from 'types/types'

interface StoryFooterProps {
  storyUserId: string
  storyId: string
  avatarsList?: Array<{
    id?: string | number
    username?: string | null
    display_name?: string | null
    avatar: {
      url: string
    } | null
  }>
  setAction: (action: StoryActionType) => any
  setIsPaused: (x: boolean) => any
  isPlayerMuted: boolean
  setIsPlayerMuted: Dispatch<SetStateAction<boolean>>
  openViewsModal: () => void
}

export const StoryFooter = ({
  avatarsList,
  storyId,
  storyUserId,
  setAction,
  setIsPaused,
  setIsPlayerMuted,
  isPlayerMuted,
  openViewsModal
}: StoryFooterProps) => {
  const loggedInUser = useUserProfile()
  const isOwnStory = loggedInUser?.id === storyUserId

  function handleMute() {
    setIsPlayerMuted(prev => !prev)
    setAction?.('longPress')
    setIsPaused(false)
  }

const groupData = useMemo(() => ({
  avatars: avatarsList?.map(viewer => ({
    id: String(viewer.id ?? viewer.username ?? viewer.display_name ?? ''),
    url: viewer.avatar?.url ?? null,
    displayName: viewer.display_name ?? viewer.username ?? ''
  })) ?? [],
  count: avatarsList?.length ?? 0
}), [avatarsList])

  return (
    <StoryFooterContainer>
      <MuteWrapper>
        <StoryMute handleMute={handleMute} isMuted={isPlayerMuted} />
      </MuteWrapper>

      {isOwnStory ? (
        avatarsList?.length ? (
<GroupCirclesStory
  group={groupData}
  onClick={openViewsModal}
/>
        ) : (
          <div onClick={openViewsModal}>
            <IconViewersSize />
          </div>
        )
      ) : (
        <div />
      )}

      {!isOwnStory && (
        <MessageInputWrapper>
          <StoryMessage
            storyId={storyId}
            setAction={setAction}
            setIsPaused={setIsPaused}
          />
        </MessageInputWrapper>
      )}
    </StoryFooterContainer>
  )
}

const MessageInputWrapper = styled.div`
  flex-grow: 1;
  display: flex;
`

const StoryFooterContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
  z-index: 5;

  @media (min-width: 768px) {
    max-width: 600px;
    left: 50%;
    transform: translateX(-50%);
  }
`

const MuteWrapper = styled.div`
  padding: 0 1rem 0 0;
  display: flex;
  align-items: center;
`